import { Component, OnInit } from '@angular/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule, SelectItem } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { formatDate } from '../../../../theme/functions/formatDate.function';

import {
    isSameMonth,
    isSameDay,
    startOfMonth,
    endOfMonth,
    startOfWeek,
    endOfWeek,
    startOfDay,
    endOfDay,
    format
} from 'date-fns';
import { CalendarEvent } from 'angular-calendar';
import { Event } from '../../class/event';
import { ActivatedRoute } from '@angular/router';
import { EventService } from '../../service/event/event.service';
import { NewnessService } from '../../service/newness/newness.service';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Newness } from '../../class/newness';
import { OpeningStation } from '../../class/opening-station';
import { config } from '../../../../../environments/config';
import { filter } from 'rxjs/operator/filter';
import { Station } from '../../class/station';
import { calendarES } from '../../../../theme/functions/calendarES';

@Component({
  selector: 'app-management-claro',
  templateUrl: './management-claro.component.html',
  styleUrls: ['./management-claro.component.scss']
})
export class ManagementClaroComponent implements OnInit {
    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    edit: Event;

    public form: FormGroup;
    public form2: FormGroup;
    public form3: FormGroup;
    public form4: FormGroup;
    public title: AbstractControl;
    public type: AbstractControl;
    public start: AbstractControl;
    public end: AbstractControl;
    public allDay: AbstractControl;
    public color: AbstractControl;
    public textColor: AbstractControl;
    public status: AbstractControl;
    public company: AbstractControl;
    public contact: AbstractControl;
    public job: AbstractControl;
    public person_in: AbstractControl;
    public identification_number: AbstractControl;
    public expired_at: AbstractControl;
    public arrival_time: AbstractControl;
    public received_by: AbstractControl;
    public confirmation_in: AbstractControl;
    public activated: AbstractControl;
    public station_id: AbstractControl;
    public zone: AbstractControl;
    public information: AbstractControl;
    public hours_plant1: AbstractControl;
    public hours_plant2: AbstractControl;
    public hours_plant3: AbstractControl;
    public level_tank1: AbstractControl;
    public level_tank2: AbstractControl;
    public level_tank3: AbstractControl;
    public backup: AbstractControl;
    public working_with: AbstractControl;

    public station_id_filter: AbstractControl;
    public employee_id_filter: AbstractControl;
    public created_by_filter: AbstractControl;
    public completed_by_filter: AbstractControl;
    public type_id_filter: AbstractControl;

    public mobile_send: AbstractControl;
    public message_send: AbstractControl;

    public listPending: any;
    public listProgress: any;
    public listDone: any;

    public listNewness: any[];

    public viewType: string;

    public visibleSidebar2: boolean;

    public first = 0;

    public eventID: Number = 0;
    public modNew = false;
    public modView = false;
    public openEvent = false;
    public header: any;
    public eventList: Event[];
    public eventCalendar: Event[];
    public eventKanban: Event[];
    public eventType: string;
    public filters: {key: string, value: string}[];
    public filtersCalendar: {key: string, value: string}[];
    public filtersKanban: {key: string, value: string}[];
    public queryEvent: string;
    public query: string;

    public totalRecords: number;
    public totalRecordsNewness: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public es: any;

    public minDate: Date;

    public optionsSelectionStatusEvent: any[];
    public optionsSelectionTypeEvent: any[];

    public calendarStart: string;
    public calendarEnd: string;

    public kanbanStart: string;
    public kanbanEnd: string;

    public selectOpeningStation: OpeningStation;

    public types: SelectItem[];

    public employeePosition: string;
    public employeePositionCreatedBy: string;
    public employeePositionCompletedBy: string;

    public modExportDialog: boolean;

    public apiUrl = config.API_ROOT;

    public form5: FormGroup;
    public f5_date_start: AbstractControl;
    public f5_date_end: AbstractControl;
    public f5_station_id: AbstractControl;
    public f5_employee_id: AbstractControl;
    public f5_administrative_division: AbstractControl;
    public f5_type_filter: AbstractControl;
    public f5_export_filter: AbstractControl;

    public exportOptions: SelectItem[];

    public modViewDialogStation: boolean;

    public selectStation: Station;
    public sticky: boolean;

    constructor(
        fb: FormBuilder,
        public eventService: EventService,
        public newnessService: NewnessService,
        public confirmationService: ConfirmationService,
        public hasPermissionService: HasPermissionService,
        public translate: TranslateService,
        private route: ActivatedRoute) {
            this.modExportDialog = false;

            this.employeePosition = '2';
            this.employeePositionCreatedBy = '3';
            this.employeePositionCompletedBy = '2,3,4';

            if (this.hasPermission('add management claro')) {
                this.types = [
                    {label: 'Todos', value: 'all'},
                    {label: 'Agendamiento', value: 'scheduling'},
                    {label: 'Activación', value: 'activation'},
                    {label: 'Emergencia', value: 'emergency'},
                    {label: 'Hora y Niveles', value: 'hours_levels'},
                    {label: 'Otros', value: 'other'}
                ];
            } else {
                this.types = [
                    {label: 'Todos', value: 'all'},
                    {label: 'Activación', value: 'activation'},
                    {label: 'Otros', value: 'other'}
                ];
            }


            this.exportOptions = [
                {label: 'Excel', value: 'excel'},
            ];

            this.optionsSelectionStatusEvent = [];
            this.optionsSelectionStatusEvent.push({label: 'pending', value: 'pending'});
            this.optionsSelectionStatusEvent.push({label: 'progress', value: 'progress'});
            this.optionsSelectionStatusEvent.push({label: 'done', value: 'done'});
            this.optionsSelectionStatusEvent.push({label: 'cancel', value: 'cancel'});

            this.optionsSelectionTypeEvent = [];
            this.optionsSelectionTypeEvent.push({label: 'Todas', value: 'all'});
            this.optionsSelectionTypeEvent.push({label: 'Agendamiento', value: 'scheduling'});
            this.optionsSelectionTypeEvent.push({label: 'Activación', value: 'activation'});
            this.optionsSelectionTypeEvent.push({label: 'Emergencia', value: 'emergency'});
            this.optionsSelectionTypeEvent.push({label: 'Hora y Niveles', value: 'hours_levels'});
            this.optionsSelectionTypeEvent.push({label: 'Otros', value: 'other'});

            this.form = fb.group({
                'title': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
                'type': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
                'start': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
                'end': [''],
                'allDay': [''],
                'color': [''],
                'textColor': [''],
                'status': [''],
                'company': [''],
                'contact': [''],
                'job': [''],
                'person_in': [''],
                'identification_number': [''],
                'expired_at': [''],
                'arrival_time': [''],
                'received_by': [''],
                'confirmation_in': [''],
                'activated': [''],
                'station_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
                'zone': [''],
                'information': [''],
                'hours_plant1': [''],
                'hours_plant2': [''],
                'hours_plant3': [''],
                'level_tank1': [''],
                'level_tank2': [''],
                'level_tank3': [''],
                'backup': [''],
                'working_with': [''],
            });
            this.title = this.form.controls['title'];
            this.type = this.form.controls['type'];
            this.start = this.form.controls['start'];
            this.end = this.form.controls['end'];
            this.allDay = this.form.controls['allDay'];
            this.color = this.form.controls['color'];
            this.textColor = this.form.controls['textColor'];
            this.status = this.form.controls['status'];
            this.company = this.form.controls['company'];
            this.contact = this.form.controls['contact'];
            this.job = this.form.controls['job'];
            this.person_in = this.form.controls['person_in'];
            this.identification_number = this.form.controls['identification_number'];
            this.expired_at = this.form.controls['expired_at'];
            this.arrival_time = this.form.controls['arrival_time'];
            this.received_by = this.form.controls['received_by'];
            this.confirmation_in = this.form.controls['confirmation_in'];
            this.activated = this.form.controls['activated'];
            this.station_id = this.form.controls['station_id'];
            this.zone = this.form.controls['zone'];
            this.hours_plant1 = this.form.controls['hours_plant1'];
            this.hours_plant2 = this.form.controls['hours_plant2'];
            this.hours_plant3 = this.form.controls['hours_plant3'];
            this.level_tank1 = this.form.controls['level_tank1'];
            this.level_tank2 = this.form.controls['level_tank2'];
            this.level_tank3 = this.form.controls['level_tank3'];
            this.backup = this.form.controls['backup'];
            this.working_with = this.form.controls['working_with'];

            this.form2 = fb.group({
                'information': ['', Validators.compose([Validators.required, Validators.minLength(2)])]
            });
            this.information = this.form2.controls['information'];

            this.form3 = fb.group({
                'station_id_filter': [''],
                'employee_id_filter': [''],
                'created_by_filter': [''],
                'completed_by_filter': [''],
                'type_id_filter': ['']
            });
            this.station_id_filter = this.form3.controls['station_id_filter'];
            this.employee_id_filter = this.form3.controls['employee_id_filter'];
            this.created_by_filter = this.form3.controls['created_by_filter'];
            this.completed_by_filter = this.form3.controls['completed_by_filter'];
            this.type_id_filter = this.form3.controls['type_id_filter'];
            this.type_id_filter.setValue('all');


            this.form4 = fb.group({
                'mobile_send': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
                'message_send': ['', Validators.compose([Validators.required, Validators.minLength(2)])]
            });
            this.mobile_send = this.form4.controls['mobile_send'];
            this.message_send = this.form4.controls['message_send'];

            this.form5 = fb.group({
                'f5_date_start': ['', [Validators.required]],
                'f5_date_end': ['', [Validators.required]],
                'f5_station_id': [''],
                'f5_employee_id': [''],
                'f5_administrative_division': [''],
                'f5_type_filter': [''],
                'f5_export_filter': [''],
            });
            this.f5_date_start = this.form5.controls['f5_date_start'];
            this.f5_date_end = this.form5.controls['f5_date_end'];
            this.f5_station_id = this.form5.controls['f5_station_id'];
            this.f5_employee_id = this.form5.controls['f5_employee_id'];
            this.f5_administrative_division = this.form5.controls['f5_administrative_division'];
            this.f5_type_filter = this.form5.controls['f5_type_filter'];
            this.f5_export_filter = this.form5.controls['f5_export_filter'];
            this.f5_type_filter.setValue('all');
            this.f5_export_filter.setValue('excel');

            this.minDate = new Date();
            this.start.setValue(this.minDate);

            this.listNewness = [];

            this.modViewDialogStation = false;
            this.sticky = false;
    }

    ngOnInit() {
        const dateStart = new Date();
        const dateEnd = new Date();
        dateStart.setHours(23, 59, 59, 59);
        dateEnd.setHours(0, 0, 0, 0);
        this.kanbanStart = dateStart.toISOString();
        this.kanbanEnd = dateEnd.toISOString();
        this.es = calendarES();

        this.eventList = [];
        this.eventCalendar = [];
        this.eventKanban = [];
        this.header = {
            left: 'prev,next today',
            center: 'title',
            right: 'month,agendaWeek,agendaDay,listDay'
        };

        this.page = 1;
        this.per_page = 100;

        this.viewType = 'calendar';

        this.filter();
    }

    public onChangeType($event) {
        if ($event === 'other') {
            this.title.setValue('Otro');
        } else {
            this.title.setValue($event);
        }
    }

    public loadEventLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        
        if (event.sortField) {
            if (event.sortOrder === -1) {
                this.sort = '-' + event.sortField;
            } else {
                this.sort = event.sortField;
            }
        } else {
            this.sort = '-created_at';
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        if (this.viewType === 'list') {
            this.getEvent();
        }
        if (this.viewType === 'calendar') {
            this.getEventCalendar();
        }
        if (this.viewType === 'kanban') {
            this.getEventKanban();
        }

        this.reloadListKanban();
    }

    // public loadEventLazy(event: LazyLoadEvent) {
    //     this.page = (event.first / this.per_page) + 1;
    //     if (event.sortOrder === -1) {
    //         this.sort =  '-' + event.sortField;
    //     } else {
    //         this.sort =  event.sortField;
    //     }
    //     this.getEvent(event.globalFilter);
    // }

    public newEvent(values: any) {
        const param = {
            'title': values.title,
            'type': values.type,
            'start': values.start,
            'end': values.end,
            'allDay': values.allDay,
            'status': values.status,
            'company': values.company,
            'contact': values.contact,
            'job': values.job,
            'person_in': values.person_in,
            'identification_number': values.identification_number,
            'expired_at': values.expired_at,
            'arrival_time': values.arrival_time,
            'received_by': values.received_by,
            'confirmation_in': values.confirmation_in,
            'activated': true,
            'station_id': values.station_id.id,
            'zone': values.zone,
            'hours_plant1': values.hours_plant1,
            'hours_plant2': values.hours_plant2,
            'hours_plant3': values.hours_plant3,
            'level_tank1': values.level_tank1,
            'level_tank2': values.level_tank2,
            'level_tank3': values.level_tank3,
            'backup': values.backup,
            'working_with': values.working_with,
            'employee_id': values.station_id.employee_id,
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.eventService.updateEvent(this.edit.id, param)
                :
                this.eventService.newEvent(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    if (this.viewType === 'list') {
                        this.getEvent();
                    }
                    if (this.viewType === 'calendar') {
                        this.getEventCalendar();
                    }
                    if (this.viewType === 'kanban') {
                        this.getEventKanban();
                    }
                        
                    this.reloadListKanban();
                                this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                        this.form.reset();
                    });
                    this.visibleSidebar2 = false;
                },
                error => {
                    if (this.viewType === 'list') {
                        this.getEvent();
                    }
                    if (this.viewType === 'calendar') {
                        this.getEventCalendar();
                    }
                    if (this.viewType === 'kanban') {
                        this.getEventKanban();
                    }
            
                    this.reloadListKanban();
                                this.msgs = [];
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    public newNewness(values: Newness) {
        const param = {
            information: values.information,
            event_id: this.edit.id
        };
        if (values && this.form.valid) {
            const promise = this.newnessService.newNewness(this.edit.id, param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.getNewness(this.edit.id);
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                        // this.form.reset();
                    });
                },
                error => {
                    if (this.viewType === 'list') {
                        this.getEvent();
                    }
                    if (this.viewType === 'calendar') {
                        this.getEventCalendar();
                    }
                    if (this.viewType === 'kanban') {
                        this.getEventKanban();
                    }
            
                    this.reloadListKanban();
            
                    this.msgs = [];
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    getNewness (id: number) {
        this.eventService.infoEvent(id).toPromise().then(
            response => {
                this.edit.newnesses = response.json().data[0].newnesses;
                this.form2.reset();
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecordsNewness = response.json().meta.total_filtered;
                } else {
                    this.totalRecordsNewness = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    getEvent() {
        this.eventService.getEvent(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.eventList = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    getEventCalendar() {
        this.eventService.getEvent(1, 1000, this.sort, undefined, this.filtersCalendar).toPromise().then(
            response => {
                this.eventCalendar = response.json().data;
                this.reloadListCalendar();
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    getEventKanban() {
        this.eventService.getEvent(1, 1000, this.sort, undefined, this.filtersKanban).toPromise().then(
            response => {
                this.eventKanban = response.json().data;
                this.reloadListKanban();
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public savedEvent(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.edit = null;
        this.modNew = false;
        if (this.viewType === 'list') {
            this.getEvent();
        }
        if (this.viewType === 'calendar') {
            this.getEventCalendar();
        }
        if (this.viewType === 'kanban') {
            this.getEventKanban();
        }

        this.reloadListKanban();
    }

    public cancelEvent () {
        this.edit = null;
        this.visibleSidebar2 = false;
        if (this.viewType === 'list') {
            this.getEvent();
        }
        if (this.viewType === 'calendar') {
            this.getEventCalendar();
        }
        if (this.viewType === 'kanban') {
            this.getEventKanban();
        }

        this.reloadListKanban();
    }

    public cancelOpeningStation () {
        this.edit = null;
        this.visibleSidebar2 = false;
        if (this.viewType === 'list') {
            this.getEvent();
        }
        if (this.viewType === 'calendar') {
            this.getEventCalendar();
        }
        if (this.viewType === 'kanban') {
            this.getEventKanban();
        }

        this.reloadListKanban();
    }

    public savedOpeningStation(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.edit = null;
        this.visibleSidebar2 = false;
        if (this.viewType === 'list') {
            this.getEvent();
        }
        if (this.viewType === 'calendar') {
            this.getEventCalendar();
        }
        if (this.viewType === 'kanban') {
            this.getEventKanban();
        }

        this.reloadListKanban();
    }

    public deleteDialog(event: Event) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(event);
            }
        });
    }

    public delete(event: Event) {
        this.eventService.deleteEvent(event.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                if (this.viewType === 'list') {
                    this.getEvent();
                }
                if (this.viewType === 'calendar') {
                    this.getEventCalendar();
                }
                if (this.viewType === 'kanban') {
                    this.getEventKanban();
                }
    
                this.reloadListKanban();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeEvent(event: Event) {
        this.putEvent(event);
    }

    public putEvent(values: Event) {
        const param = {
            'status': values.status,
            'activated': values.activated
        };
        if (values) {
            const promise = this.eventService.updateEvent(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    public reloadListKanban() {
        this.listPending = [];
        this.listProgress = [];
        this.listDone = [];

        this.eventKanban.forEach(element => {
            if (element.status === 'pending') {
                element.textColor = '#FFFFFF';
                element.color = '#ffc107';
                this.listPending.push (element);
            }

            if (element.status === 'progress') {
                element.textColor = '#FFFFFF';
                element.color = '#17a2b8';
                this.listProgress.push (element);
            }

            if (element.status === 'done') {
                element.textColor = '#FFFFFF';
                element.color = '#28a745';
                this.listDone.push (element);
            }
        });
    }

    public reloadListCalendar() {
        this.eventCalendar.forEach(element => {
            if (element.status === 'pending') {
                element.textColor = '#FFFFFF';
                element.color = '#ffc107';
            }

            if (element.status === 'progress') {
                element.textColor = '#FFFFFF';
                element.color = '#17a2b8';
            }

            if (element.status === 'done') {
                element.textColor = '#FFFFFF';
                element.color = '#28a745';
            }

            this.translate.get(element.type).subscribe((res: string) => {
                element.title = '#' + element.id + ' - ' + res + ' - ' + element.station.name + ' - ' + element.employee.name + ' - ' +
                element.company + ' - ' + element.job + ' - ' + element.identification_number + ' - ' + element.person_in;
            });
        });
    }

    public showNewEvent() {
        this.edit = null;
        this.form.reset();
        this.form2.reset();
        this.visibleSidebar2 = true;
    }

    public showEvent(event) {
        this.visibleSidebar2 = true;
        this.edit = event;
        this.title.setValue(this.edit.title);
        this.type.setValue(this.edit.type);
        if (this.edit.start !== '' && this.edit.start !== null) {
            this.start.setValue(new Date(this.edit.start));
        }
        if (this.edit.end !== '' && this.edit.end !== null) {
            this.end.setValue(new Date(this.edit.end));
        }
        this.allDay.setValue(this.edit.allDay);
        this.color.setValue(this.edit.color);
        this.textColor.setValue(this.edit.textColor);
        this.status.setValue(this.edit.status);
        this.type.setValue(this.edit.type);
        this.activated.setValue(this.edit.activated);
        this.station_id.setValue(this.edit.station);
        this.zone.setValue(this.edit.zone);
        this.hours_plant1.setValue(this.edit.hours_plant1);
        this.hours_plant2.setValue(this.edit.hours_plant2);
        this.hours_plant3.setValue(this.edit.hours_plant3);
        this.level_tank1.setValue(this.edit.level_tank1);
        this.level_tank2.setValue(this.edit.level_tank2);
        this.level_tank3.setValue(this.edit.level_tank3);
        this.backup.setValue(this.edit.backup);
        this.working_with.setValue(this.edit.working_with);

        this.company.setValue(this.edit.company);
        this.contact.setValue(this.edit.contact);
        this.job.setValue(this.edit.job);
        this.person_in.setValue(this.edit.person_in);
        this.identification_number.setValue(this.edit.identification_number);
        this.expired_at.setValue(this.edit.expired_at);
        this.arrival_time.setValue(this.edit.arrival_time);
        this.confirmation_in.setValue(this.edit.confirmation_in);
        this.received_by.setValue(this.edit.received_by);

        this.selectOpeningStation = new OpeningStation();
        this.selectOpeningStation.station = this.edit.station;
        this.selectOpeningStation.station_id = this.edit.station_id;
        this.selectOpeningStation.ericcson_id = this.edit.identification_number;
        this.selectOpeningStation.person_in = this.edit.person_in;
        this.selectOpeningStation.company = this.edit.company;
        if (!this.edit.job) {
            if (this.edit.type === 'emergency') {
                this.selectOpeningStation.job = 'Emergencia';
            }
        } else {
            this.selectOpeningStation.job = this.edit.job;
        }

        this.form2.reset();

        let start;
        if (event.start) {
            if (event.start._i) {
                start = event.start._i;
            } else {
                start = event.start;
            }
        } else {
            start = '';
        }

        let end;
        if (event.end && event.end !== '') {
            if (event.end._i) {
                end = event.end._i;
            } else {
                end = event.end;
            }
        } else {
            end = '';
        }

        let text;
        this.translate.get(event.type).subscribe((res: string) => {
            let start2;
            let end2;
            text = res + '\n ' + event.station.name;
            if (start) {
                start2 = formatDate(start);
                text = text + '\n Inicio: ' + start2;
            }
            if (end) {
                end2 = formatDate(end);
                text = text + '\n Fin: ' + end2;
            }
            if (event.company) {
                text = text + '\n Compañía: ' + event.company;
            }
            if (event.contact) {
                text = text + '\n Contacto: ' + event.contact;
            }
            if (event.job) {
                text = text + '\n Trabajo: ' + event.job;
            }
            if (event.person_in) {
                text = text + '\n Quién Ingresa: ' + event.person_in;
            }
            if (event.identification_number) {
                text = text + '\n Id: ' + event.identification_number;
            }
        });

        this.mobile_send.setValue(this.edit.employee.mobile);
        this.message_send.setValue(text);
    }

    public listView() {
        this.getEvent();

        this.viewType = 'list';
    }

    public calendarView() {
        this.getEventCalendar();

        this.viewType = 'calendar';
    }

    public kanbanView() {
        this.getEventKanban();
        this.reloadListKanban();

        this.viewType = 'kanban';
    }

    public onDropSuccessPending(e) {
        e.status = 'pending';
        this.reloadListKanban();
        const index = this.findElement(this.eventKanban, e.id);
        this.eventKanban[index].status = 'pending';
        this.eventKanban[index].color = '#ffc107';
        this.putEvent(e);
    }

    public onDropSuccessProgress(e) {
        e.status = 'progress';
        this.reloadListKanban();
        const index = this.findElement(this.eventKanban, e.id);
        this.eventKanban[index].status = 'progress';
        this.eventKanban[index].color = '#17a2b8';
        this.putEvent(e);
    }

    public onDropSuccessDone(e) {
        e.status = 'done';
        this.reloadListKanban();
        const index = this.findElement(this.eventKanban, e.id);
        this.eventKanban[index].status = 'done';
        this.eventKanban[index].color = '#28a745';
        this.putEvent(e);
    }

    handleEventClick(e) {
        this.showEvent(e.calEvent);
    }

    public changeStartDate(event) {
        this.end.setValue('');
    }

    public findElement (list, search) {
        let find = -1;
        let itera = 0;
        list.forEach(element => {
            if (element.id === search) {
                find = itera;
            }
            itera++;
        });
        return find;
    }

    public cleanFormFilter() {
        this.form3.reset();
        this.employee_id_filter.setValue('');
        this.station_id_filter.setValue('');
        this.created_by_filter.setValue('');
        this.completed_by_filter.setValue('');
        this.type_id_filter.setValue('');
        this.filter();
    }

    openWhatsapp(event) {
        window.open('https://api.whatsapp.com/send?phone=' + '57' + event.mobile_send + '&text=' + event.message_send, '_blank');
    }

    printToCart(printSectionId: string) {
        let popup;
        const innerContents = document.getElementById(printSectionId).innerHTML;
        popup = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        popup.document.open();
        popup.document.write('<html>' +
                            '<head>' +
                            '<style>' +
                            '.fc-button-group { display: none;}' +
                            '.fc-left { display: none;}' +
                            '.fc-scroller { overflow-x: unset !important; overflow-y: unset !important;}' +
                            '</style>' +
                            '</head>' +
                            '<body onload="window.print()">' +
                            innerContents +
                            '</body>' +
                            '</html>');
        popup.document.close();
    }

    public checkStation (values) {
        let check = false;
        if (values) {
            if (values.station_id) {
                if (values.station_id.id) {
                    check = true;
                }
            }
        }
        return check;
    }

    public showExportDialog() {
        this.modExportDialog = true;
    }

    public cancelExport() {
        this.modExportDialog = false;
    }

    public exportReport(values) {
        this.exportReportExcel(values);
    }

    public exportReportExcel(values) {
        const f5_date_start = formatDate(values.f5_date_start);
        const f5_date_end = formatDate(values.f5_date_end);

        let url = this.apiUrl + '/events/excel?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_limit=100000&_sort=-id&';

        if (f5_date_start) {
            url = url + 'created_at-min=' + f5_date_start + '&';
        }

        if (f5_date_end) {
            url = url + 'created_at-max=' + f5_date_end + '&';
        }

        if (values.f5_station_id) {
            url = url + 'station_id-in=' + values.f5_station_id.id + '&';
        }

        if (values.f5_employee_id) {
            url = url + 'employee_id-in=' + values.f5_employee_id.id + '&';
        }

        if (values.f5_administrative_division) {
            url = url + 'administrative_division=' + values.f5_administrative_division + '&';
        }

        if (values.f5_type_filter !== 'all' && values.f5_type_filter !== '') {
            url = url + 'type-in=' + values.f5_type_filter + '&';
        } else if (values.f5_type_filter == 'all' && !this.hasPermission('add management claro')){
            url = url + 'type-in=' + 'activation,other' + '&';
        }

        console.log(url);
        window.open(url, '_blank');
    }

    public filterEvent (event, values) {
        this.filter(values, event);
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public filter (values?, event?) {
        this.filters = [];
        this.filtersCalendar = [];
        this.filtersKanban = [];
        this.first = 0;

        if (this.route.snapshot.url[0].path === 'management-claro')  {
            if (this.route.snapshot.url[1].path === 'event')  {
                this.eventType = 'manage-claro';
                this.filters.push({key: 'event_position_id', value: this.eventType});
            }
        }

        if (values) {
            if (values.station_id_filter) {
                this.filters.push({'key': 'station_id-lk', 'value': values.station_id_filter.id});
            }
            if (values.employee_id_filter) {
                this.filters.push({'key': 'employee_id-lk', 'value': values.employee_id_filter.id});
            }
            if (values.created_by_filter) {
                this.filters.push({'key': 'created_by_id-lk', 'value': values.created_by_filter.id});
            }
            if (values.completed_by_filter) {
                this.filters.push({'key': 'done_by_id-lk', 'value': values.completed_by_filter.id});
            }
            if (values.type_id_filter !== 'all' && values.type_id_filter !== '') {
                this.filters.push({'key': 'type-lk', 'value': values.type_id_filter});
            } else if (values.type_id_filter == 'all' && !this.hasPermission('add management claro')){
                this.filters.push({'key': 'type-lk', 'value': 'activation,other'});
            }
        }

        this.filters.forEach(element => {
            this.filtersCalendar.push({'key': element.key, 'value': element.value});
        });
        if (event) {
            this.calendarStart = new Date(event.view.start._i).toISOString();
            this.calendarEnd = new Date(event.view.end._i).toISOString();
            this.filtersCalendar.push({'key': 'start-min', 'value': this.calendarStart});
            this.filtersCalendar.push({'key': 'end-max', 'value': this.calendarEnd});
        } else if (this.calendarStart && this.calendarEnd) {
            this.filtersCalendar.push({'key': 'start-min', 'value': this.calendarStart});
            this.filtersCalendar.push({'key': 'end-max', 'value': this.calendarEnd});
        }

        this.filters.forEach(element => {
            this.filtersKanban.push({'key': element.key, 'value': element.value});
        });
        this.filtersKanban.push({'key': 'start-max', 'value': this.kanbanStart});
        this.filtersKanban.push({'key': 'end-max', 'value': this.kanbanEnd});


        this.query = undefined;

        if (this.viewType === 'list') {
            this.getEvent();
        }
        if (this.viewType === 'calendar') {
            this.getEventCalendar();
        }
        if (this.viewType === 'kanban') {
            this.getEventKanban();
        }

        this.reloadListKanban();
    }

    public viewDialogStation(station: Station, sticky: boolean) {
        this.selectStation = station;
        this.modViewDialogStation = true;
        this.sticky = sticky;
    }

    public viewHideDialogStation() {
        if (!this.sticky) {
            this.modViewDialogStation = false;
        }
    }

    public cancelStation (res) {
        this.selectStation = null;
        this.modViewDialogStation = false;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/management-claro/management-claro.component.ts